<div class="row conteneur-contacter-ma-caf-primo-par-courriel-cnaf" id="conteneur-contacter-ma-caf-primo-par-courriel-cnaf">
    <div class="col-sm-12">
        <h3 class="titre-bloc-cnaf filet-cnaf text-uppercase" tabindex="-1" >
            Par mail
        </h3>
    </div>
    <!-- Loading -->
    <div class="col-sm-12" [ngSwitch]="etat">
        <div *ngSwitchCase="'loading'" class="progress">
            <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar">
                Chargement en cours...
            </div>
        </div>
        <div *ngSwitchCase="'nonAutorise'">
            <div class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-alert"></span>
                <p class="inline-cnaf">Vous n'êtes pas autorisé à envoyer un mail.</p>
            </div>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a routerLink="/contactcaf" routerLinkActive="active" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    <span class="btn-block">Retour Contacter ma Caf</span>
                </a>
            </div>
        </div>
        <div *ngSwitchCase="'error'">
            <div class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-alert"></span>
                <p class="inline-cnaf">Un incident technique s'est produit.
                <br aria-hidden="true"/>Merci de renouveler votre démarche.</p>
            </div>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a routerLink="/contactcaf" routerLinkActive="active"
                    class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    <span class="btn-block">Retour Contacter ma Caf</span>
                </a>
            </div>
        </div>

        <!-- Fin Loading -->
        <!-- Loaded -->
        <div *ngSwitchCase="'loaded'">
            <p class="texte-info-cnaf">Tous les champs sont obligatoires, sauf mention contraire.</p>
            <form [formGroup]="contactMaCafPrimoForm" ngCnafFormFocusToFirstInvalid (ngSubmit)="envoyer()"
                cnaf-focus-on-error novalidate autocomplete="off">
                <p>
                    Contactez nous en complétant le formulaire ci-dessous:
                </p>
                <!-- Champs Nom de famille et nom d'usage-->
                <div class="row">
                    <div class="col-sm-6">
                        <label class="label-form-cnaf" for="nomFamille">Votre nom</label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (submitted || fcontact.nomFamille.touched) && fcontact.nomFamille.errors }">
                            <input [(ngCnafFocus)]="focusTitre"  type="text" id="nomFamille" class="form-control" title="champ obligatoire"
                                formControlName="nomFamille" aria-describedby="nomFamilleHelp nomFamilleErreur">
                                <span class="sr-only" id="nomFamilleHelp">Champ obligatoire</span>                               
                            <div id="nomFamilleErreur"
                                *ngIf="!(fcontact.nomFamille.errors && (submitted || fcontact.nomFamille.touched))">
                                <p aria-hidden="true">&nbsp;</p>
                            </div>
                            <div role="alert" *ngIf="fcontact.nomFamille.errors && (submitted || fcontact.nomFamille.touched)"
                                class="text-danger">
                                <p *ngIf="fcontact.nomFamille.errors.required" id="nomFamilleErreur">Veuillez indiquer votre nom</p>
                                <p *ngIf="fcontact.nomFamille.errors.pattern" id="nomFamilleErreur">Indiquer votre nom en toutes lettres</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="label-form-cnaf" for="nomUsage">Votre nom d'usage (du conjoint,
                            ex-conjoint, père et/ou mère), facultatif</label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (submitted || fcontact.nomUsage.touched) && fcontact.nomUsage.errors }">
                            <input  type="text" id="nomUsage" class="form-control" title="champ facultatif"
                                formControlName="nomUsage" aria-describedby="nomUsageHelp">
                            <span class="sr-only" id="nomUsageHelp">Champ facultatif</span>                      
                            <div id="nomUsageErreur"
                                *ngIf="!(fcontact.nomUsage.errors && (submitted || fcontact.nomUsage.touched))">
                                <p aria-hidden="true">&nbsp;</p>
                            </div>
                            <div role="alert" *ngIf="fcontact.nomUsage.errors && (submitted || fcontact.nomUsage.touched)"
                                class="text-danger">
                                <p *ngIf="fcontact.nomUsage.errors.pattern" id="nomUsageErreur">Indiquer votre nom d'usage en toutes lettres</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Champ Prénom -->
                <label class="label-form-cnaf" for="prenom">Votre prénom</label>
                <div class="form-group" [ngClass]="{'has-error': (submitted || fcontact.prenom.touched) && fcontact.prenom.errors }">
                    <input  type="text" id="prenom" class="form-control" formControlName="prenom" title="champ obligatoire"
                        aria-describedby="prenomHelp prenomErreur">
                    <span class="sr-only" id="prenomHelp">Champ obligatoire</span>                
                    <div id="prenomErreur" *ngIf="!(fcontact.prenom.errors && (submitted || fcontact.prenom.touched))">
                            <p aria-hidden="true">&nbsp;</p>
                    </div>
                    <div role="alert" *ngIf="fcontact.prenom.errors && (submitted || fcontact.prenom.touched)" class="text-danger">
                            <p *ngIf="fcontact.prenom.errors.required" id="prenomErreur">Veuillez indiquer votre prénom</p>
                            <p *ngIf="fcontact.prenom.errors.pattern" id="prenomErreur">Indiquer votre prénom en toutes lettres</p>
                    </div>
                </div>
                <!-- Champ Adresse Mail et confirmation-->
                <div class="row">
                    <div class="col-sm-6">
                        <label class="label-form-cnaf" for="email">Votre adresse mail</label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (submitted || fcontact.email.touched) && fcontact.email.errors }">
                            <input  type="text" id="email" class="form-control" formControlName="email" title="champ obligatoire"
                                aria-describedby="emailHelp emailErreur">
                            <span class="sr-only" id="emailHelp">Champ obligatoire, saisissez votre email, par exemple test@caf.fr</span>
                            <div id="emailErreur" *ngIf="!(fcontact.email.errors && (submitted || fcontact.email.touched))">
                                    <p aria-hidden="true">&nbsp;</p>
                            </div>
                            <div role="alert" *ngIf="fcontact.email.errors && (submitted || fcontact.email.touched)" class="text-danger">
                                <p *ngIf="fcontact.email.errors.required" id="emailErreur">Veuillez indiquer votre adresse mail
                                </p>
                                <p *ngIf="fcontact.email.errors.pattern" id="emailErreur">Veuillez indiquer votre adresse mail
                                </p>
                            </div>
                        </div>                       
                    </div>
                    <div class="col-sm-6">
                        <label class="label-form-cnaf" for="emailConfirm">Confirmer votre adresse
                            mail</label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (submitted || fcontact.emailConfirm.touched) && (fcontact.emailConfirm.errors || contactMaCafPrimoForm.errors)  }">
                            <input  type="text" id="emailConfirm" class="form-control" title="champ obligatoire"
                                formControlName="emailConfirm" aria-describedby="emailConfirmHelp emailConfirmErreur">
                            <span class="sr-only" id="emailConfirmHelp">Champ obligatoire, saisissez votre email, par exemple test@caf.fr</span>
                            <div id="emailConfirmErreur"
                            *ngIf="!(fcontact.emailConfirm.errors && (submitted || fcontact.emailConfirm.touched))">
                                <p aria-hidden="true">&nbsp;</p>
                            </div>
                            <div role="alert"
                                *ngIf="(fcontact.emailConfirm.errors || contactMaCafPrimoForm.errors) && (submitted || fcontact.emailConfirm.touched)"
                                class="text-danger">
                                <p *ngIf="fcontact.emailConfirm.errors?.required" id="emailConfirmErreur">Veuillez indiquer votre
                                    adresse mail
                                </p>
                                <p *ngIf="fcontact.emailConfirm.errors?.pattern" id="emailConfirmErreur">Veuillez indiquer votre
                                    adresse mail
                                </p>
                                <p *ngIf="contactMaCafPrimoForm.errors?.mismatch" id="emailConfirmErreur">La saisie de
                                    l’adresse mail est différente de la précédente
                                </p>
                            </div>
                        </div>
                    </div>
                </div>                
                <!-- Champ Téléphone -->
                <label class="label-form-cnaf" for="telephone">Votre numéro de téléphone</label>
                <div class="form-group"
                    [ngClass]="{'has-error': (submitted || fcontact.telephone.touched) && fcontact.telephone.errors }">
                    <input  type="text" id="telephone" class="form-control" formControlName="telephone" title="champ obligatoire"
                        aria-describedby="telephoneHelp telephoneErreur">
                    <span class="sr-only" id="telephoneHelp">Champ obligatoire, Indiquez les 10 chiffres de votre numéro de téléphone</span>
                    <div id="telephoneErreur" *ngIf="!(fcontact.telephone.errors && (submitted || fcontact.telephone.touched))">
                            <p aria-hidden="true">&nbsp;</p>
                    </div>
                    <div role="alert" *ngIf="fcontact.telephone.errors && (submitted || fcontact.telephone.touched)" class="text-danger">
                        <p *ngIf="fcontact.telephone.errors?.required" id="telephoneErreur">Veuillez indiquer les 10
                            chiffres
                            de
                            votre numéro de téléphone</p>
                        <p *ngIf="fcontact.telephone.errors?.pattern" id="telephoneErreur">Veuillez indiquer les 10
                            chiffres
                            de votre numéro de téléphone</p>
                    </div>      
                </div>
                <!-- Champ Adresse -->
                <label class="label-form-cnaf" for="adresse">Votre adresse</label>
                <div class="form-group"
                    [ngClass]="{'has-error': (submitted || fcontact.adresse.touched) && fcontact.adresse.errors }">
                    <input  type="text" id="adresse" class="form-control" formControlName="adresse" title="champ obligatoire"
                        aria-describedby="adresseHelp adresseErreur">
                    <span class="sr-only" id="adresseHelp">Champ obligatoire ,indiquez votre adresse</span>               
                    <div id="adresseErreur" *ngIf="!(fcontact.adresse.errors && (submitted || fcontact.adresse.touched))">
                            <p aria-hidden="true">&nbsp;</p>
                    </div>
                    <div role="alert" *ngIf="fcontact.adresse.errors && (submitted || fcontact.adresse.touched)" class="text-danger">
                        <p *ngIf="fcontact.adresse.errors?.required" id="adresseErreur">Veuillez saisir votre adresse
                        </p>
                        <p *ngIf="fcontact.adresse.errors.pattern" id="adresseErreur">Indiquer votre adresse en toutes lettres
                        </p>
                    </div>
                </div>
                <!-- Champ Code Postal Commune -->
                <label class="label-form-cnaf" for="codePostalCommune">Votre code
                    postal/commune</label>
                <div class="form-group"
                    [ngClass]="{'has-error': (((submitted || fcontact.codePostalCommune.touched) && fcontact.codePostalCommune.errors) || codePostalKO) }">
                    <input role="combobox"  type="text" id="codePostalCommune" class="form-control"
                        formControlName="codePostalCommune" [typeahead]="listeLocalites" [typeaheadOptionsLimit]="10"
                        [typeaheadMinLength]="3" [typeaheadAsync]="true" [typeaheadWaitMs]="400"
                        typeaheadOptionField="lib" (typeaheadOnSelect)="codePostalOnSelect($event)" (typeaheadOnBlur)="codePostalOnBlur($event)" (typeaheadNoResults)="codePostalNoResult($event)"
                        oninput="this.value = this.value.toUpperCase()" title="champ obligatoire"
                        [typeaheadSelectFirstItem]="true" placeholder="Ex : 75001 PARIS" 
                        aria-describedby="codePostalCommuneHelp codePostalCommuneErreur">
                    <span class="sr-only" id="codePostalCommuneHelp">Indiquez votre code postal, par exemple 75001 et choisissez votre commune dans la liste</span>                
                    <div id="codePostalCommuneErreur"
                        *ngIf="!((fcontact.codePostalCommune.errors && (submitted || fcontact.codePostalCommune.touched)) || codePostalKO)">
                        <p aria-hidden="true">&nbsp;</p>
                    </div>
                    <div role="alert" *ngIf="((fcontact.codePostalCommune.errors && (submitted || fcontact.codePostalCommune.touched)) || codePostalKO)"
                        class="text-danger">
                        <p *ngIf="(fcontact.codePostalCommune.errors?.required || fcontact.codePostalCommune.errors?.minlength || codePostalKO)" id="codePostalCommuneErreur">Veuillez saisir
                            votre code postal ou commune
                        </p>
                    </div>
                </div>
                <!-- Champ objetMessage -->
                <div class="dropdown-cnaf">
                    <label class="label-form-cnaf" for="idObjetMsg">Votre question
                        concerne</label>
                    <div class="form-group"
                        [ngClass]="{'has-error': (submitted || fcontact.objetMessage.touched) && fcontact.objetMessage.errors }">
                        <select  formControlName="objetMessage" id="idObjetMsg" 
                            class="form-control select-cnaf" aria-describedby="objetMessageHelp objetMessageErreur">
                            <option value='' selected disabled> --- Sélectionnez dans la liste... ---</option>
                            <option class="hidden-xs" *ngFor="let objetMessage of listeObjectMessage" [ngValue]="objetMessage"
                                [disabled]="!objetMessage.selectionnable">
                                {{objetMessage.libelleCaffr}}</option>
                            <option class="visible-xs" *ngFor="let objetMessage of listeObjectMessage" [ngValue]="objetMessage"
                                [disabled]="!objetMessage.selectionnable">
                                {{objetMessage.libelleMobile}}</option>
                        </select>
                        <span class="sr-only" id="objetMessageHelp">Champ obligatoire, choisissez l'objet de votre message</span>
                    </div>                
                    <div id="objetMessageErreur" *ngIf="!(fcontact.objetMessage.errors && (submitted || fcontact.objetMessage.touched))">
                            <p aria-hidden="true">&nbsp;</p>
                    </div>
                    <div role="alert" *ngIf="fcontact.objetMessage.errors && (submitted || fcontact.objetMessage.touched)"
                        class="text-danger">
                        <p *ngIf="fcontact.objetMessage.errors.required" id="objetMessageErreur">Veuillez sélectionner une
                            question</p>
                    </div>
                </div>
                <!-- champ motif réclamation -->
                <div  *ngIf="selObjetMessage.code =='INFO_REC'">
                    <div class="dropdown-cnaf">
                        <label class="label-form-cnaf" for="idMotifReclamation">Votre réclamation
                            concerne</label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (submitted || fcontact.motifReclamation.touched) && fcontact.motifReclamation.errors }">
                            <select  formControlName="motifReclamation" id="idMotifReclamation"
                                class="form-control select-cnaf"
                                aria-describedby="motifReclamationHelp motifReclamationErreur"
                                required >
                                <option value='' selected disabled > --- Sélectionnez dans la liste... ---</option>
                                <option class="hidden-xs" *ngFor="let motifReclamation of listeMotifReclamation"
                                    [ngValue]="motifReclamation" [disabled]="!motifReclamation.selectionnable">
                                    {{motifReclamation.libelleCaffr}}</option>
                                <option class="visible-xs" *ngFor="let motifReclamation of listeMotifReclamation"
                                    [ngValue]="motifReclamation" [disabled]="!motifReclamation.selectionnable">
                                    {{motifReclamation.libelleMobile}}</option>
                            </select>
                            <span class="sr-only" id="motifReclamationHelp">Champ obligatoire, choisissez le motif de votre réclamation dans la liste</span>
                        </div>
                        <div id="motifReclamationErreur"
                            *ngIf="!(fcontact.motifReclamation.errors && (submitted || fcontact.motifReclamation.touched))">
                            <p aria-hidden="true">&nbsp;</p>
                        </div>
                        <div role="alert" *ngIf="fcontact.motifReclamation.errors && (submitted || fcontact.motifReclamation.touched)"
                            class="text-danger">
                            <p *ngIf="fcontact.motifReclamation.errors.required" id="motifReclamationErreur">Veuillez
                                sélectionner un
                                motif</p>
                        </div>
                    </div>
                </div>
                <!-- champ prestation -->
                <div *ngIf="selObjetMessage.code =='INFO_REC' && selMotifReclamation.famille =='dossier'">
                    <div class="dropdown-cnaf">
                        <label class="label-form-cnaf" for="idPrestation">Votre réclamation concerne
                            une prestation</label>
                        <div class="form-group"
                            [ngClass]="{'has-error': (submitted || fcontact.prestation.touched) && fcontact.prestation.errors }">
                            <select  formControlName="prestation" id="idPrestation"
                                class="form-control select-cnaf" aria-describedby="prestationHelp prestationErreur"
                                required >
                                <option value='' selected disabled> --- Sélectionnez dans la liste... ---</option>
                                <option class="hidden-xs" *ngFor="let prestation of listePrestation" [ngValue]="prestation" [disabled]="!prestation.selectionnable">
                                    {{prestation.libelleCaffr}}</option>
                                <option class="visible-xs" *ngFor="let prestation of listePrestation" [ngValue]="prestation" [disabled]="!prestation.selectionnable">
                                        {{prestation.libelleMobile}}</option>
                            </select>
                            <span class="sr-only" id="prestationHelp">Champ obligatoire, choisissez une prestation dans la liste</span>

                        </div>
                        <div id="prestationErreur" *ngIf="!(fcontact.prestation.errors && (submitted || fcontact.prestation.touched))">
                                <p aria-hidden="true">&nbsp;</p>
                        </div>
                        <div role="alert" *ngIf="fcontact.prestation.errors && (submitted || fcontact.prestation.touched)"
                            class="text-danger">
                            <p *ngIf="fcontact.prestation.errors.required" id="prestationErreur">Veuillez sélectionner une
                                prestation</p>
                        </div>
                    </div>
                </div>
                <!-- Champ Message -->
                <label class="label-form-cnaf" for="idMessage">Votre message</label>
                <div class="form-group"
                    [ngClass]="{'has-error': (submitted || fcontact.message.touched) && fcontact.message.errors }">
                    <textarea  id="idMessage" class="form-control" formControlName="message" title="champ obligatoire"
                        aria-describedby="messageHelp messageErreur" rows="5" placeholder="Saisissez votre message...">
                    </textarea>
                    <span class="sr-only" id="messageHelp">Champ obligatoire, saisissez votre méssage</span>
                    <div id="messageErreur" *ngIf="!(fcontact.message.errors && (submitted || fcontact.message.touched))">
                            <p aria-hidden="true">&nbsp;</p>
                    </div>
                    <div role="alert" *ngIf="fcontact.message.errors && (submitted || fcontact.message.touched)" class="text-danger">
                        <p *ngIf="fcontact.message.errors.required" id="messageErreur">Veuillez saisir votre message
                        </p>
                        <p *ngIf="fcontact.message.errors.pattern" id="messageErreur">Indiquer votre message en toutes lettres
                        </p>
                    </div>
                </div>
                <!-- Champ acceptCU -->
                <div class="form-group" [ngClass]="{'has-error': (submitted && fcontact.acceptCU.errors) }">
                    <label for="acceptCU" class="label-form-cnaf">
                        <ng-cnaf-checkbox id="acceptCU"  class="pull-left" formControlName="acceptCU"
                            aria-describedby="acceptCUHelp acceptCUErreur" aria-labelledby="labelCUCheckbox">
                        </ng-cnaf-checkbox><span id="labelCUCheckbox">J'accepte les conditions d'utilisations et j'autorise la Caf à utiliser
                        mes coordonnées pour me contacter pour la gestion de mon dossier.</span>
                        <span class="sr-only" id="acceptCUHelp">si vous acceptez les conditions d'utilisation, cocher la case</span>
                    </label>
                    <div id="acceptCUErreur" *ngIf="!(fcontact.acceptCU.errors && submitted)">
                    </div>
                    <div role="alert" *ngIf="fcontact.acceptCU.errors && submitted" class="text-danger">
                        <p *ngIf="fcontact.acceptCU.errors.required" id="acceptCUErreur">Veuillez cocher les conditions
                            d'utilisation
                        </p>
                    </div>
                </div>
                <!-- Boutons quitter - Envoyer -->
                <div class="row">
                <div class="form-group text-center">
                    <p class="text-left">Suite à l'envoi de votre mail, vous allez recevoir un accusé de
                        réception dans votre messagerie. Si tel n'est pas le cas, merci de vérifier l'adresse
                        mail que vous avez communiquée et si nécessaire de la rectifier.</p>
 
                    <div class="col-sm-4 col-xs-6 pull-right">
                        <button type="submit" class="btn btn-form-cnaf btn-block btn-active-cnaf align-middle-cnaf"
                            >Envoyer</button>
                    </div>
                    <div class="col-sm-4 col-xs-6">
                            <button  id="button-quitter" type="button" class="btn btn-form-cnaf btn-block btn-active-cnaf pull-left align-middle-cnaf"
                            (click)="confirmerClick()">
                            Quitter
                            </button>
                    </div>
                </div>
            </div>
            </form>
        </div>
        <!-- postFormOk -->
        <div *ngSwitchCase="'postFormOk'">
            <p>Votre message a été transmis à la {{nomCaf}}.<br />Il sera traité dans les
                meilleurs délais.</p>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a [href]="urlRetourAccueil" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    <span class="">Retour accueil</span>
                </a>
            </div>
        </div>
        <!-- End postFormOk -->

        <!-- postFormKo -->
        <div *ngSwitchCase="'postFormKo'">
            <div class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-danger"></span>
                <p class="inline-cnaf">Suite à un incident technique, votre message n'a pas pu
                nous être transmis.<br aria-hidden="true" />Merci de réessayer plus tard.</p>
            </div>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a href=""
                    class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf"><span>Retour
                        accueil</span></a>
            </div>
        </div>
        <!-- End FormPostKO -->
    </div>